import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Text } from "@pentabd/ui";

import { InputTextRow, MultiFile, SelectController } from "@components";

import { useLanguage } from "@hooks/useLanguage";

import { getConvertedMasterData } from "@helpers/masterDataConvert";

import {
  ADD_CONFIDENTIAL_REPORT,
  AcrFormDataType,
} from "@validations/HRM/employee/acrValidation";

export const AddNewConfidential = ({
  performanceComment,
  performanceStatus,
  performanceEligibility,
}: any) => {
  const { t } = useTranslation();
  const { language } = useLanguage();

  const {
    register,
    formState: { errors },
    control,
    setValue,
  } = useFormContext<AcrFormDataType>();

  return (
    <div className="py-8 d-flex flex-column gap-8">
      <Text
        weight="semibold"
        size="lg"
        color="dark"
        className="pb-8 d-block border-bottom"
      >
        {t("EMPLOYEE.ACR_INFO.HEADING_3")}
      </Text>
      <InputTextRow
        register={{ ...register(ADD_CONFIDENTIAL_REPORT.YEAR) }}
        label="EMPLOYEE.ACR_INFO.FORM.YEAR"
        error={errors}
        required
        restriction
      />
      <InputTextRow
        register={{
          ...register(
            ADD_CONFIDENTIAL_REPORT.YEAR_BASED_OBTAINED_NUMBER_OF_ACR,
          ),
        }}
        label="EMPLOYEE.ACR_INFO.FORM.YEAR_BASED_NUMBER"
        error={errors}
        required
      />
      <div className="row">
        <div className="col-md-12 col-lg-3">
          <Text weight="semibold" size="sm" color="title">
            {t("EMPLOYEE.ACR_INFO.FORM.OVERALL_APPRAISAL.LABEL")}
          </Text>
        </div>
        <div className="col-lg-7">
          <div className="d-grid grid-cols-sm-2 grid-cols-md-1 grid-cols-lg-2 gap-8">
            <SelectController
              placeholder={t(
                "EMPLOYEE.ACR_INFO.FORM.OVERALL_APPRAISAL.PERFORMANCE_ELIGIBILITY.PLACEHOLDER",
              )}
              control={control}
              name={ADD_CONFIDENTIAL_REPORT.ELIGIBILITY}
              register={{ ...register(ADD_CONFIDENTIAL_REPORT.ELIGIBILITY) }}
              options={getConvertedMasterData(performanceEligibility, language)}
              setValue={setValue}
            />
            <SelectController
              placeholder={t(
                "EMPLOYEE.ACR_INFO.FORM.OVERALL_APPRAISAL.PERFORMANCE_STATUS.PLACEHOLDER",
              )}
              control={control}
              name={ADD_CONFIDENTIAL_REPORT.STATUS}
              register={{ ...register(ADD_CONFIDENTIAL_REPORT.STATUS) }}
              options={getConvertedMasterData(performanceStatus, language)}
              setValue={setValue}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 col-lg-3">
          <Text weight="semibold" size="sm" color="title">
            {t("EMPLOYEE.ACR_INFO.FORM.PERFORMANCE_COMMENT.LABEL")}
          </Text>
        </div>
        <div className="col-lg-7">
          <div className="d-grid grid-cols-sm-2 grid-cols-md-1 grid-cols-lg-2 gap-8 align-items-center">
            <Text color="title">
              {t("EMPLOYEE.ACR_INFO.FORM.PERFORMANCE_COMMENT.TITLE")}:
            </Text>
            <SelectController
              placeholder={t(
                "EMPLOYEE.ACR_INFO.FORM.PERFORMANCE_COMMENT.PLACEHOLDER",
              )}
              control={control}
              name={ADD_CONFIDENTIAL_REPORT.COMMENT}
              register={{ ...register(ADD_CONFIDENTIAL_REPORT.COMMENT) }}
              options={getConvertedMasterData(performanceComment, language)}
              setValue={setValue}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-3">
          <Text weight="semibold" size="sm" color="title">
            {t("EMPLOYEE.ACR_INFO.FORM.UPLOAD_ACR.LABEL")}
            <span className="text-danger">&#42;</span>
          </Text>
        </div>
        <div className="col-lg-7">
          <MultiFile
            id={ADD_CONFIDENTIAL_REPORT.UPLOAD_ACR}
            control={control}
            setValue={setValue}
            register={register}
            errors={errors}
            fileDetails={["date", "memorialNo"]}
          />
        </div>
      </div>
    </div>
  );
};
